import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa"; // FontAwesome location pin icon
import axios from "axios";

const Footer = () => {
  const [homeProducts, setHomeProducts] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    fetchHomeProducts();
  }, []);
  const fetchHomeProducts = () => {
    axios
      .post(`${BASE_URL}/api/product/getHome`) // your API endpoint
      .then((response) => {
        if (response.data.product.length > 0) {
          setHomeProducts(response.data.product); // Store product data
        }
      })
      .catch((err) => {});
  };

  return (
    <footer className="footer-area">
      <div className="footer-main">
        <div className="container">
          <div className="row gy-4">
            {/* Brand */}
            <div className="col-lg-3 col-md-6">
              <div className="widget-item">
                <a href="/" className="footer-logo">
                  <img src="/assets/img/sachi_logo.png" alt="Sachi Logo" />
                </a>
                <p className="footer-about">
                  With over 20 years of experience, Sachi Products delivers
                  premium-quality products at competitive prices, built on trust
                  and long-term relationships.
                </p>
              </div>
            </div>

            {/* Info */}
            <div className="col-lg-2 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title">Information</h4>
                <ul className="footer-links">
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact_us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Categories */}
            <div className="col-lg-3 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title">Product Categories</h4>
                <ul className="footer-links">
                  {homeProducts.slice(0, 7).map((product) => (
                    <li key={product.id}>
                      <Link
                        to={`/product_images/${product.id}/${product.name}`}
                      >
                        {product.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contact */}
            <div className="col-lg-4 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title">Contact Us</h4>
                <div className="footer-contact">
                  <FaMapMarkerAlt className="contact-icon" />
                  <span className="ml-10">
                    1st Floor, Sachi House, Above Patel Ice Cream, Commerce Six
                    Rd, Navrangpura, Ahmedabad
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container text-center">
          <p className="footer-copyright-text">
            © 2026{" "}
            <a href="https://sachiproducts.com" className="footer-link">
              <strong>Sachi Products</strong>
            </a>
            <span className="footer-separator">
              {" "}
              | Designed & Developed by{" "}
              <a
                href="https://theaditech.in"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link developer-link"
              >
                <strong>The Adi Tech</strong>
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
